import { IStandarDataTableColumn } from "@ioip/core/lib";
import { IDataTableColumnSchema } from "../../types/IDataTableColumn";
import Attribute from "./Attribute";
import Entity from "./Entity";
import { EntityViewColumnFormat } from "../../studio-types";

export interface IEntityViewColumnProps {
    entity: Entity;
    schema: IDataTableColumnSchema;
}

export class EntityViewColumn {

    #props: IEntityViewColumnProps;

    constructor(props: IEntityViewColumnProps) {
        this.#props = props;
    }

    get id(): string {
        return this.#props.schema.id;
    }

    get headerText(): string {
        return this.#props.schema.headerText;
    }

    get minWidth(): number {
        return this.#props.schema.minWidth;
    }

    get maxWidth(): number {
        return this.#props.schema.maxWidth;
    }

    get order(): number {
        return this.#props.schema.order;
    }

    get isResizable(): boolean {
        return this.#props.schema.isResizable;
    }

    get required(): boolean {
        return false;
    }

    get attribute(): Attribute {
        return this.#props.entity.getAttribute(this.#props.schema.attributeId);
    }

    get format(): EntityViewColumnFormat {
        return this.#props.schema.format;
    }

    toStandarDataTableColumn(): IStandarDataTableColumn<EntityViewColumn> {
        return {
            name: this.headerText,
            minWidth: this.minWidth,
            maxWidth: this.maxWidth,
            isResizable: this.isResizable,
            isSorted: false,
            isSortedDescending: false,
            onRender: (item: any) => item[ this.attribute.code ]
        }
    }

}
